enum SectionType {
  STRAIGNT = "Straight section",
  BEND = "Bend",
  VERTICAL = "Vertical section"
}

export default SectionType